import MyDataHelps from "@careevolution/mydatahelps-js";

export default function getGarminProviderID() {
    var garminProviderID = 6327;
    if (!MyDataHelps.baseUrl || MyDataHelps.baseUrl.startsWith("https://mdhorg.ce.dev")) {
        garminProviderID = 1384;
    }
    return garminProviderID;
}